const formatNumber = (value, decimalFix) => {
    const num = parseFloat(value);

    if (!isNaN(num)) {
        return num.toFixed(decimalFix);
    }

    return value;
};

const formatPower = (value, decimalFix) => {
    const num = parseFloat(value);

    if (!isNaN(num)) {
        const value = Math.abs(num)
        // if (value > 1000000000) {
        //     const newVal = (value / 1000000000);
        //     return newVal.toFixed(decimalFix) + "GW";
        // } else if (value > 1000000) {
        //     const newVal = (value / 1000000);
        //     return newVal.toFixed(decimalFix) + "MW";
        // }
        // else 
        if (value > 1000) {
            const newVal = (value / 1000);
            return newVal.toFixed(decimalFix) + "kW";
        } else {
            return value.toFixed(decimalFix) + "W";
        }
    }

    return value;
};

const formatcsvTable = (value, decimalFix) => {
    const num = parseFloat(value);

    if (!isNaN(num)) {

        const newVal = (value / 1000);
        return newVal.toFixed(decimalFix) + "kW";
    }

    return value;
}

const formatGraphPower = (value, decimalFix) => {
    const num = parseFloat(value);

    if (!isNaN(num)) {

        const newVal = (value / 1000);
        return newVal.toFixed(decimalFix) + "kWh";
    }

    return value;
}

const checkDatatype = (values) => {
    let newValue = [];
    for (let i = 0; i < values.length; i++) {
        if (typeof values[i] === "number") {
            newValue.push(values[i].toFixed(2));
        } else {
            newValue.push(0);
        }
    }
    return newValue;
}

const getRandomValue = () => {
    return Math.random()
}

const formatValue = (val, decimalFix) => {
    if (typeof val === 'string') {
        return val
    } else {
        const value = Math.abs(val);
        // if (value > 1000000000) {
        //     const newVal = (value / 1000000000).toFixed(2);
        //     return newVal;
        // } else if (value > 1000000) {
        //     const newVal = (value / 1000000).toFixed(2);
        //     return newVal;
        // }
        // else {
        const newVal = (value / 1000).toFixed(!!decimalFix ? decimalFix : 2);
        return newVal;
        // }
    }
}

const formatValueDetail = (val, decimalFix) => {
    if (typeof val === 'string') {
        return val
    } else {
        const newVal = (val / 1000).toFixed(!!decimalFix ? decimalFix : 2);
        return newVal;
        // }
    }
}


const formatMass = (val) => {
    const value = Math.abs(val);
    if (value > 1000000000000) {
        const newVal = (value / 1000000000000).toFixed(1);
        return { newVal, unit: "Mt" };
    } else if (value > 1000000) {
        const newVal = (value / 1000000).toFixed(1);
        return { newVal, unit: "t" };
    }
    else if (value > 1000) {
        const newVal = (value / 1000).toFixed(1);
        return { newVal, unit: "kg" };
    } else {
        const newVal = value.toFixed(1);
        return { newVal, unit: "g" };
    }
}

const formatRadiation = (value, decimalFix) => {
    const num = parseFloat(value);

    if (!isNaN(num)) {

        const newVal = (value / 1000);
        return newVal.toFixed(decimalFix) + "kWh/m²";
    }

    return value;
}

const checkValue = (value) => {
    let newArray = [];
    value.forEach((data) => {
        if (typeof (data) === 'string') {
            newArray.push(0)
        } else {
            newArray.push(Math.abs(data))
        }
    })
    return newArray;
}

const formatDataCSV = (value) => {
    let data = [];
    value.forEach((val, index) => {
        data.push(formatValue(value[index]));
    });
    return data;
}

const formatArray = (arr) => {
    let newArray = arr.filter(data => typeof data === 'number');
    const maxData = Math.max(newArray.reduce((a, b) => Math.max(a, b), 0));
    return maxData;
}

const roundToNearest = (val, nearest) => {
    return Math.ceil(val / nearest) * nearest;
}

const idExists = (arr, id) => {
    if (!arr.some(item => item.id === id) || isNaN(id)) {
        return false
    } else {
        return true
    }
}

export { getRandomValue, formatNumber, formatPower, checkDatatype, formatValue, formatMass, formatRadiation, checkValue, formatDataCSV, formatArray, roundToNearest, formatValueDetail, formatcsvTable, idExists, formatGraphPower };